export interface SignPressType {
  label: string;
  value: number;
}

let signPressTypes: SignPressType[] = [];

export async function fetchSignPressTypes(): Promise<SignPressType[]> {
  if (signPressTypes.length === 0) {
    const response = await fetch('/api/sign-press-types');
    if (!response.ok) {
      throw new Error('Failed to fetch sign press types');
    }
    signPressTypes = await response.json();
  }
  return signPressTypes;
}

export function getSignPressTypes(): SignPressType[] {
  return [...signPressTypes];
}
